// todo: remove eslint-disable
/* eslint-disable @typescript-eslint/no-explicit-any */
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { v4 as uuidv4 } from 'uuid';

type ErrorsStackProps = {
    errors: string[],
    errorMessage: string,
}

const alertStyle = {
  fontSize: '14px',
  fontWeight: '400',
  lineHeight: '20px',
  letterSpacing: '0.15px',
};

export const ErrorsStack = ({ errors, errorMessage }: ErrorsStackProps):JSX.Element => {
  return (
    <Stack sx={ { width: '100%' } } spacing={ 2 }>
      {errors.length > 0 && errors.map((errorValue:any) => {
        return (
          <Alert
            key={ uuidv4() }
            severity="error"
            sx={ alertStyle }
          >{errorValue.fieldName || errorValue}
          </Alert>
        );
      })}
      {errors.length === 0 && <Alert severity="error" sx={ alertStyle }>{errorMessage}</Alert>}
    </Stack>
  );
};
